import { Injectable } from '@angular/core';
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { ApiUrlConstant } from "../../../../constants/api-url.constant";
import { Observable } from "rxjs";
import { element } from '@angular/core/src/render3';
import { color } from 'highcharts';
const month = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

@Injectable()
export class WidgetStatusBreakupService {
  baseUrl = environment.gateWayHost;
  editItem: any;

  constructor(
    public generic: GenericHttpService,
    private apiUrl: ApiUrlConstant
  ) { }

  getData(options): Observable<any> {
    const option = {
      method: "GET",
      url: `${this.baseUrl}${options.url}`,
      //url: './assets/data/status-breakup-stack.json',
      query: options.params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.processstatusBreakup)
    );
  }

  getfilters(option): Observable<any> {
    const Options = {
      method: "GET",
      url: `${this.baseUrl}${option.url}`,
      query: option.params
    };
    return this.generic.httpRequest(Options).pipe(
      catchError(this.generic.handleError),
      map(this.generic.responseData)
    );
  }

  processstatusBreakup(data: any) {
    let allValues = []
    const categories = [];
    const statusKey = { "to_be_invoiced": "To Be invoiced", "invoiced": "BBND" };
    const statusArray = ["to_be_invoiced", "invoiced"]
    //console.log(data.data);
    if (data.data.length === 0) return null;
    data.data.forEach(ele => {
      Object.keys(ele).forEach(elem => {
        if (statusArray.indexOf(elem) > -1) {
          categories.unshift(statusKey[elem])
          if (elem === "to_be_invoiced") {
            ele[elem].forEach(status => {
              allValues.unshift(status);
            })
          } else {
            ele[elem].forEach(status => {
              allValues.push(status);
            })
          }
        }
      })

    })
    return { allValues, categories };
  }

  createChart(chartData, Options) {

    const chart = JSON.parse(JSON.stringify(HSET.chartData));
    const Alldata = [];
    const OneData = [];
    const output = [];
    let stackChart: any = []
    const result = [];
    chartData.allValues.forEach((item) => {
      const existing = output.filter((v, i) => {
        return v.interval == item.interval;
      });
      if (existing.length) {
        const existingIndex = output.indexOf(existing[0]);
        output[existingIndex].quantity = output[existingIndex].quantity.concat(item.quantity);
      } else {
        if (typeof item.quantity != 'string')
          item.quantity = [item.quantity];
        output.push(item);
      }
    });

    stackChart = output.map((ele, index) => {
      let createChart = {
        name: ele.interval,
        data: [],
        index: index,
        stack: "male",
        color: ele.color,
        //tooltip: { valueSuffix: "k" }
      }
      createChart.data = [...ele.quantity];
      return createChart
    })
    chart.xAxis.categories = chartData.categories.length > 1 ? ["To Be invoiced", "BBND"] : chartData.categories;
    chart.series = []
    chart.series = [...stackChart]
    return chart;
  }
}
